<template>
    <div id="challenge-page" class="content challenge" v-if="leftTime && user.uid">
        <Question
            v-if="!result.result_id"
            :result.sync="result"
        ></Question>
        <!-- 剩余次数减去本次答题 -->
        <Result
            v-else
            :result="result"
            :leftTime="leftTime - 1"
        ></Result>
    </div>
</template>

<script>
import Question from './components/Question'
import Result from './components/Result'
import { userApi } from '@/apis'
import { Toast } from 'vant';
export default {
    name: 'challengePage',
    components: {
        Question,
        Result
    },
    computed: {
        leftTime () {
            return this.agriMaxChallengeTime - (this.user.new_agri_challenge_quiz_times || 0)
        }
    },
    data () {
        return {
            agriMaxChallengeTime: 0,
            result: {},
            user: {}
        }
    },
    methods: {
        async getInfo () {
            const logined = await this.$auth.check({ source: 'agriculture' })
            if (logined) {
                const { body } = await userApi.userUidGet({
                    params: {
                        uid: logined
                    }
                })
                this.user = body
                if (body.new_agri_challenge_quiz_times >= this.agriMaxChallengeTime) {
                    Toast.fail({
                        message: '今日挑战次数用完啦，明天记得回来看看',
                        duration: 2000,
                        onClose: () => {
                            this.location.replace('/quiz/agriculture')
                        }
                    })
                }
            }
        },
        async getConfig () {
            Object.assign(this, await this.GLOBAL.getConfig('agriMaxChallengeTime'))
        }
    },

    async mounted () {
        await this.getConfig()
        this.getInfo()
    }
}
</script>

<style lang="less">
.van-toast {
    width: auto;
    max-width: 75%;
    .van-toast__text {
        white-space: pre;
    }
}
</style>